import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import Tooltip from 'components/atoms/tooltip';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class ProjectionPointsType extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('ProjectionPointsType', value));
    }

    render() {
        const {projectionPointsType, tooltip, sportConfig} = this.props;
        let {options} = this.props;

        let tooltipText = tooltip || 'Choose to Optimize Based on Fantasy Points or Projection';

        options = options || {
            userPoints: 'Fantasy Points',
            adminPoints: 'Proj',
        };

        if (sportConfig.isModeBacktest() && inArray(sportConfig.getSport(), Const.BACKTEST_SPORTS)) {
            options['fantasyPoints'] = 'Final FPts';
        }

        return (
            <div className="input-info">
                <Tooltip subject={tooltipText} />
                <SimpleSelect
                    key={projectionPointsType.getProjectionPointsType()}
                    value={projectionPointsType.getProjectionPointsType()}
                    options={options}
                    onChange={::this.onChange}
                    testId="projection-system-dropdown"
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {projectionPointsType, sportConfig} = state;

    return {
        projectionPointsType,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(ProjectionPointsType);
